import router from '../../router'
import {allowOnlyAuthorized} from '../../router/routeGuards'

import Video from './Video.vue'
import AppHeader from '../../components/layout/Header'

// Setup routes
export default () => {
  router.addRoutes([
    {
      path: '/video/:videoId',
      name: 'video',
      components: {
        default: Video,
        header: AppHeader
      },
      meta: {
        dontShowInMenu: true,
        highlightFiles: true,
      },
      beforeEnter: allowOnlyAuthorized()
    }
  ])
}
